import React from "react";
import { Text, Button, withFocusable } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { getAppState } from "../../../state";
import { getVoucherDurationText } from "../../../services/copyService";

const ButtonFocus = withFocusable(Button);
const voucherSettingsFocusPath = "voucherSettingsSection_passThru";

export const EVoucher = ({ enterHandler, sectionItemFocused }) => {
  const { userLogged, voucherData } = getAppState();
  const voucherDuration = voucherData && voucherData.duration && getVoucherDurationText(voucherData.duration.duration);
  const buttonLabel = !userLogged ? "join" : "start";
  return (
    <>
      <Text text={i18n.get("pages.settings.eVoucher.title")} />
      <ButtonFocus
        label={i18n.get(`global.eVoucher.${buttonLabel}`, voucherDuration)}
        focusPath={voucherSettingsFocusPath}
        onEnterPress={enterHandler}
        onMouseUp={enterHandler}
        dataSnUp={""}
        dataSnDown={""}
        dataSnLeft={i18n.directionFlip(`@secondaryItem_${sectionItemFocused}`, "")}
        dataSnRight={i18n.directionFlip("", `@secondaryItem_${sectionItemFocused}`)}
      />
    </>
  );
};
